import { render, staticRenderFns } from "./CategoriesInput.vue?vue&type=template&id=dda6378e&"
import script from "./CategoriesInput.vue?vue&type=script&lang=js&"
export * from "./CategoriesInput.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesInput.vue?vue&type=style&index=0&id=dda6378e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports